import React, { useState } from "react";
import Icon from "../Icon";

export const BoxShrinkable = ({className, title, tools, children}) => {
    const [show, setShow] = useState(true);
    
    return (
        <div className={`box-shrinkable ${className ?? ''} ${show ? 'open' : 'closed'}`}>
            {(title || tools) &&
                <div className="header">
                    <span>{title}</span>
                    <button onClick={() => setShow(!show)}>
                        <Icon name="arrow-dropdown" />
                    </button>
                </div>
            }
            <div className="body">
                {children}
            </div>
        </div>
    );
}

export default BoxShrinkable;